// --- Helpers ---
/**
 * Extracts clean YouTube ID from many URL formats
 * @param {string} url YouTube URL
 * @return {string|null}
 */
function getYouTubeId( url ) {

	try {

		const u = new URL( url );
		if ( u.hostname.includes( 'youtu.be' ) ) {

			return u.pathname.slice( 1 );

		}
		// youtube.com/watch?v=<id>
		if ( u.searchParams.has( 'v' ) ) {

			return u.searchParams.get( 'v' );

		}
		const embedIdx = u.pathname.indexOf( '/embed/' );
		if ( embedIdx !== -1 ) {

			return u.pathname.slice( embedIdx + 7 );

		}
		const shortsIdx = u.pathname.indexOf( '/shorts/' );
		if ( shortsIdx !== -1 ) {

			return u.pathname.slice( shortsIdx + 8 );

		}

	} catch ( e ) {
		// ignore
	}
	return null;

}

/**
 * Builds a safe, modern embed URL
 * @param {string} id YouTube video ID
 * @return {string}
 */
function buildEmbedUrl( id ) {

	const params = new URLSearchParams( {
		autoplay: '1',
		rel: '0',
		modestbranding: '1',
		playsinline: '1'
	} );
	return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;

}

// --- Init ---
document.querySelectorAll( '.b-youtube-video' ).forEach( ( block ) => {

	const btn = block.querySelector( '.b-youtube-video__play' );
	const url = block.getAttribute( 'data-youtube' );

	if ( !btn || !url ) {

		return;

	}

	btn.addEventListener( 'click', ( e ) => {

		e.preventDefault();
		e.stopPropagation();

		const id = getYouTubeId( url );
		if ( !id ) {

			console.warn( 'YouTube: invalid URL', url );
			return;

		}

		block.innerHTML = '';

		const wrap = document.createElement( 'div' );
		wrap.style.position = 'relative';
		wrap.style.paddingBottom = '56.25%'; // 16:9
		wrap.style.height = '0';
		wrap.style.overflow = 'hidden';
		wrap.style.borderRadius = '12px';

		const iframe = document.createElement( 'iframe' );
		iframe.src = buildEmbedUrl( id );
		iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
		iframe.allowFullscreen = true;
		iframe.referrerPolicy = 'strict-origin-when-cross-origin';

		Object.assign( iframe.style, {
			position: 'absolute',
			inset: '0',
			width: '100%',
			height: '100%',
			border: '0',
			display: 'block'
		} );

		wrap.appendChild( iframe );
		block.appendChild( wrap );

	}, { once: true } );

} );
